var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmooth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smooth_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 345.33 345.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smooth_svg__linear-gradient",
    x1: 14.16,
    y1: 319.09,
    x2: 255.71,
    y2: 100.02,
    gradientTransform: "matrix(1 0 0 -1 0 348)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#944B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E3A81"
  })), /*#__PURE__*/React.createElement("style", null, ".smooth_svg__cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "smooth_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smooth_svg__Color_icons",
    "data-name": "Color icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smooth_svg__Smooth"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#smooth_svg__linear-gradient)"
    },
    d: "M0 0h345.33v345.33H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "smooth_svg__cls-2",
    d: "M111.87 65.9C103.07 69.05 95.56 78 96.2 89c0 .52.29 8 .36 8.54l-18.42 6.94c9.23 2.14 12.17 2.52 19.55-.26 1.23-.46 6.19-2.36 6-6.52 0-1.26-.29-9.53-.17-10.73.53-5.23 2.66-9.77 6.81-11.33 5.1-1.92 7.18 2.88 8.64 8l48.65 170c6.66 23.29 32.66 38.25 60.95 27.59 16.08-6.06 24.4-15.1 23.72-32.56s-19.29-43.25-2.61-56.87l-56-25.32c-9.22 19.25 3.64 48 13.34 65.28 2 3.46 5.62 14.68.7 16.53s-10.32-6.37-11.91-10.55L135 77.57c-4.29-12.18-14.33-14.82-23.13-11.67Zm39.21 86.44a5.92 5.92 0 0 1 7.65 3.39 6 6 0 0 1-3.48 7.68 5.91 5.91 0 0 1-7.59-3.5 5.84 5.84 0 0 1 3.37-7.54Zm7.29 21.79a5.92 5.92 0 0 1 7.6 3.51 5.84 5.84 0 0 1-3.37 7.54 5.91 5.91 0 0 1-7.65-3.38 6 6 0 0 1 3.42-7.67Zm7.25 21.87a5.84 5.84 0 0 1 7.54 3.37v.06a5.92 5.92 0 0 1-3.39 7.64 6 6 0 0 1-7.68-3.47 5.92 5.92 0 0 1 3.53-7.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "smooth_svg__cls-2",
    d: "m262 187.79.65-1.44a3.15 3.15 0 0 0-1.57-4.17l-69.68-31.56a3.15 3.15 0 0 0-4.17 1.57l-.66 1.44a3.17 3.17 0 0 0 1.58 4.17l69.72 31.56a3.16 3.16 0 0 0 4.13-1.57Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmooth);
export default __webpack_public_path__ + "static/media/smooth.8d49f9da2dd8b36a15624a11aa7ea669.svg";
export { ForwardRef as ReactComponent };